<template>
  <v-dialog
    v-model="isOpen"
    fullscreen
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
  >
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="chiudiDialog()">
        <v-icon>close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title >Scorte</v-toolbar-title>
    </v-toolbar>

    <!-- Pagina scorte -->
    <scorte :articolo="codArt" @chiudi="chiudiDialog"></scorte>
  </v-dialog>
</template>


<script>
import scorte from "@/views/magazzino/Scorte.vue";

export default {
  components: {
    scorte
  },

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    codArt: ""
  }),

  methods: {
    chiudiDialog(salvato) {
      this.isOpen = false;

      if (salvato) this.$store.commit("app/setAzione", "aggiornaScorta");
    }
  },

  mounted() {},

  computed: {
    isOpen: {
      get() {
        return this.active;
      },
      set(q) {
        this.$emit("update:active", q);
      }
    }
  },

  watch: {
    isOpen(v) {
      // NOTA: quando la dialog è aperta, carico l'articolo selezionato se presente
      this.codArt = v ? this.$store.getters["app/getArticoloSelezionato"] : "";
    }
  }
};
</script>
